var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgBolt = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 18,
    viewBox: "0 0 10 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.67609 18C3.49276 18 3.34276 17.9333 3.22609 17.8C3.10943 17.6667 3.06776 17.5083 3.10109 17.325L4.00109 11H0.501091C0.251091 11 0.0967583 10.9333 0.0380916 10.8C-0.0199084 10.6667 0.0177582 10.4833 0.151092 10.25L5.85109 0.275C5.88443 0.191667 5.95109 0.125 6.05109 0.075C6.15109 0.025 6.24276 0 6.32609 0C6.50943 0 6.65943 0.0666667 6.77609 0.2C6.89276 0.333333 6.93443 0.491667 6.90109 0.675L6.00109 7H9.50109C9.75109 7 9.90509 7.06667 9.96309 7.2C10.0218 7.33333 9.98443 7.51667 9.85109 7.75L4.15109 17.725C4.11776 17.8083 4.05109 17.875 3.95109 17.925C3.85109 17.975 3.75943 18 3.67609 18Z",
    fill: "url(#paint0_linear_1540_4342)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1540_4342",
    x1: 3.80156,
    y1: 7.8,
    x2: 5.00156,
    y2: 15.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6352DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#493AB1"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBolt, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/bolt.faf37206.svg";
export { ForwardRef as ReactComponent };